export default __webpack_public_path__ + "static/media/icon-impression.bef29dd6.svg";